import React from 'react';
import utils from '../../utils';
import config from '../internetConfig';
import metrics from '../internetMetrics';

export default function JournalResult(props) {
	const result = Object.assign({}, props && props.result);
	const title = result.title || '';
	const date = result.date || '';
	const description = result.description || '';

	// get result file type
	var target = '';
	var fileType = String(utils.getResultFileType(result)).toUpperCase();
	if (fileType) {
		target = '_blank';
	}

	//specific date formatting
	const dateArr = date.split('-');
	let month = '';
	let day = '';
	const numMonth = parseInt(dateArr[1]);
	month = utils.formatMonth(numMonth);
	day = dateArr[2] ? parseInt(dateArr[2], 10) : '';
	const formattedDate = dateArr[0] !== '' ? month + ' ' + day + ', ' + dateArr[0] : '';

	return (
		<div className="result">
			<div className="result-title">
				<a href={result.url} onClick={(e) => metrics.event(e, 'cdcsitesearch-journals-link')}>
					{fileType ? (
						<span>
							<small>[{fileType.toUpperCase()}]</small>
							<span dangerouslySetInnerHTML={{ __html: title }}></span>
						</span>
					) : (
						<span dangerouslySetInnerHTML={{ __html: title }}></span>
					)}
				</a>
			</div>
			<div className="result-description" dangerouslySetInnerHTML={{ __html: description }}></div>
			<div className="ml-auto d-md-flex result-date">{formattedDate}</div>
		</div>
	);
}
